import '../../common/polyfills'
import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import '@mfs/common/tailwind.css'

import { NoResultsMessage } from './no-results-message'

const root = document.getElementById('root')

hydrateRoot(root, <NoResultsMessage pclnBootstrapData={window.PCLN_BOOTSTRAP_DATA} />)
